<template>
  <div class="container">
    <div class="main">
      <el-dialog :visible="visibleDialog" title="验证手机" width="480px" @opened="dialogOpenHandler"
                 @close="dialogCloseHandler" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-row type="flex" class="row-bg dialog-row" justify="center">
          <el-col :span="4">手机号码：</el-col>
          <el-col :span="14">{{ phone }}</el-col>
        </el-row>
        <el-row type="flex" class="row-bg dialog-row" style="height: 40px;line-height: 40px;" justify="center"
                :gutter="5">
          <el-col :span="4">校验码：</el-col>
          <el-col :span="10" class="dialog-code">
            <el-input v-model.trim="phoneCode" maxlength="6"></el-input>
            <div class="dialog-hint" v-show="smsError===''">请输入您的手机收到的验证码</div>
            <div class="dialog-hint" style="color: red;" v-show="smsError!==''">{{smsError}}</div>
          </el-col>
          <el-col :span="4">
            <count-down-button ref="resendCDBtn" type="primary" :time="60" @click="resendClickHandler"
                               :click-start="true">
              重发
            </count-down-button>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center">
          <el-col :offset="4" :span="14">
            <el-button type="primary" @click="registerAffirmHandler">提交</el-button>
          </el-col>
        </el-row>
      </el-dialog>
      <div class="register-box">
        <div class="register-form">
          <div>
            <div class="title">欢迎注册叮咚智造</div>
            <div class="login-info">
              已有叮咚智造账号？
              <router-link :to="{name:'Login'}" class="other-link">快速登录&nbsp;&gt;</router-link>
            </div>
          </div>
          <div class="input-row" style="color: red;">{{ serverError }}</div>
          <div class="input-row">
            <el-input v-model.trim="phone" @blur="verifyPhone" maxlength="11" placeholder="请输入手机号码"></el-input>
            <div class="errmsg">{{ errmsg['phone'] }}</div>
          </div>
          <div class="input-row">
            <el-popover placement="right" trigger="focus" width="280">
              <el-input v-model="password" type="password" @blur="verifyPassword" slot="reference"
                        placeholder="设置你的登录密码"></el-input>
              <div class="input-hint">
                <div>
                  <right-or-wrong-icon :res="passwordVerify['len']"></right-or-wrong-icon>
                  密码长度6-20字符
                </div>
                <div>
                  <right-or-wrong-icon :res="passwordVerify['char']"></right-or-wrong-icon>
                  只能包含字母、数字及标点符号（不包括空格）
                </div>
                <div>
                  <right-or-wrong-icon :res="passwordVerify['count']"></right-or-wrong-icon>
                  字母、数字和标点符号至少包含2种
                </div>
              </div>
            </el-popover>
            <div class="errmsg">{{ errmsg['pwd'] }}</div>
          </div>
          <div class="input-row">
            <el-popover placement="right" trigger="focus" width="240">
              <el-input v-model="password1" slot="reference" @blur="verifyRepetitivePassword"
                        type="password" placeholder="请再次输入你的密码"></el-input>
              <div class="input-hint">请再次输入你的密码</div>
            </el-popover>
            <div class="errmsg">{{ errmsg['pwd1'] }}</div>
          </div>
          <div class="input-row">
            <verify-image v-model="refreshCode" @blur="verifyCode" :form-key="formKey"
                          @change="code=$event"></verify-image>
            <div class="errmsg">{{ errmsg['code'] }}</div>
          </div>
          <el-button type="primary" style="width:100%;background-color: #00b7d3;" @click="registerHandler">
            同意条款并注册
          </el-button>
          <div class="input-row clause-links">
            <el-checkbox v-model="clauseCheck"></el-checkbox>
            <a class="other-link" href="">《叮咚智造网站服务条款》</a> | <a class="other-link" href="">《法律声明和隐私条款》</a>
            <div class="errmsg">{{ errmsg['clause'] }}</div>
          </div>

        </div>
      </div>
    </div>
	<footer-layout></footer-layout>
  </div>
</template>

<script>
  import VerifyImage from '@/components/fields/VerifyImage'
  import RightOrWrongIcon from '@/components/fields/RightOrWrongIcon'
  import CountDownButton from '@/components/fields/CountDownButton'
  import FooterLayout from '@/components/layout/FooterLayout'
  export default {
    name: 'Register',
    components: {FooterLayout, CountDownButton, RightOrWrongIcon, VerifyImage},
    data() {
      return {
        formKey: '',            // 表单key
        phone: '',              // 手机号码
        password: '',           // 密码
        password1: '',          // 确认密码
        refreshCode: false,     // 是否刷新验证码 true刷新
        code: '',               // 验证码
        errmsg: [],             // 表单验证错误信息
        passwordVerify: [],     // 密码三种规则验证结果
        asyncCodeVerify: false, // 验证异步验证结果
        phoneExistVerify: 0,    // 号码存在验证 0 未验证 1 号码已存在 2 可以使用
        clauseCheck: false,     // 服务条款勾选
        visibleDialog: false,   // 是否显示手机验证框
        smsError: '',           // 短信发送错误信息
        phoneCode: '',          // 短信验证码
        serverError: '',        // 服务器错误信息
      }
    },
    watch: {
      password(nv, ov) {
        this.verifyPasswordFormat()
		this.verifyRepetitivePassword()
      },
      code(nv, ov) {
        if (nv.length === 6) {
          this.verifyCode()
        }
      },
    },
    methods: {
      /**
       * 验证手机号码
       * @param nonEmpty boolean： true 进行非空检查， false不进行非空检查
       * @returns {boolean}
       */
      verifyPhone(nonEmpty) {
        if (nonEmpty !== true && this.phone === '') {
          this.phoneExistVerify = 0
          this.$set(this.errmsg, 'phone', '')
          return true
        }
        if (this.phone === '') {
          this.phoneExistVerify = 0
          this.$set(this.errmsg, 'phone', '请输入你的手机号码')
          return false
        }
        if (/^1[23456789]\d{9}$/.test(this.phone) === false) {
          this.phoneExistVerify = 0
          this.$set(this.errmsg, 'phone', '输入的手机号码格式错误')
          return false
        }
        this.$set(this.errmsg, 'phone', '')
        if (this.phoneExistVerify === 0 || this.phoneExistVerify === 1) {
          this.$api.user.phoneExist(this.phone).then(res => {
            if (res.data === false) {
              this.phoneExistVerify = 2
            } else {
              this.phoneExistVerify = 1
              this.$set(this.errmsg, 'phone', '手机号码已存在')
            }
          })
        }
        return true
      },
      /**
       * 密码格式验证
       * @returns {boolean}
       */
      verifyPasswordFormat() {
        console.log('pwd change')
        let res = true
        // 长度检测
        if (this.password.length < 6 || this.password.length > 20) {
          res = false
          this.$set(this.passwordVerify, 'len', false)
        } else {
          this.$set(this.passwordVerify, 'len', true)
        }
        // 字符检测
        console.log(/^[0-9a-zA-Z!@#$%^&*()_\-+={\[}\]|\\<,>.?/]+$/.test(this.password))
        if (/^[0-9a-zA-Z!@#$%^&*()_\-+={\[}\]|\\<,>.?/]+$/.test(this.password)) {
          this.$set(this.passwordVerify, 'char', true)
        } else {
          res = false
          this.$set(this.passwordVerify, 'char', false)
        }
        // 字符种类检测
        let rex = /^(?![a-zA-Z]+$)(?!\d+$)(?![!@#$%^&*()_\-+={\[}\]|\\<,>.?/]+$)[0-9a-zA-Z!@#$%^&*()_\-+={\[}\]|\\<,>.?/]+$/
        if (rex.test(this.password)) {
          this.$set(this.passwordVerify, 'count', true)
        } else {
          res = false
          this.$set(this.passwordVerify, 'count', false)
        }
        return res
      },
      /**
       * 验证密码
       * @param nonEmpty
       * @returns {boolean}
       */
      verifyPassword(nonEmpty) {
        if (nonEmpty !== true && this.password === '') {
          this.$set(this.errmsg, 'pwd', '')
          return true
        }
        // 非空检测
        if (this.password === '') {
          this.$set(this.errmsg, 'pwd', '请设置登录密码')
          return false
        }
        if (this.verifyPasswordFormat() === false) {
          this.$set(this.errmsg, 'pwd', '密码设置不符合要求')
          return false
        }
        this.$set(this.errmsg, 'pwd', '')
        return true
      },
      /**
       * 验证密码
       * @param nonEmpty
       * @returns {boolean}
       */
      verifyRepetitivePassword(nonEmpty) {
        if (nonEmpty !== true && this.password1 === '') {
          this.$set(this.errmsg, 'pwd1', '')
          return true
        }
        if (this.password1 === '') {
          this.$set(this.errmsg, 'pwd1', '请再次输入你的密码')
          return false
        }
        if (this.password !== this.password1) {
          this.$set(this.errmsg, 'pwd1', '两次输入的密码不一致，请重新输入')
          return false
        }
        this.$set(this.errmsg, 'pwd1', '')
        return true
      },
      /**
       * 验证验证码
       */
      verifyCode() {
        this.asyncCodeVerify = false
        if (this.code.length === 6) {
          this.$api.common.verifyImgCode(this.formKey, this.code).then(res => {
            if (res.data === true) {
              this.$set(this.errmsg, 'code', '')
              this.asyncCodeVerify = true
            } else {
              this.$set(this.errmsg, 'code', '验证码错误，请重新输入')
              // 刷新验证码
              this.refreshCode = true
              this.asyncCodeVerify = false
            }
          })
        } else {
          this.$set(this.errmsg, 'code', '验证码错误，请重新输入')
        }
      },
      /**
       * 验证整个表单
       * @returns {boolean|boolean}
       */
      verifyForm() {
        let res = true
        // 验证手机号码
        res = this.verifyPhone(true) && res
        // 验证密码
        res = this.verifyPassword(true) && res
        // 重复密码验证
        res = this.verifyRepetitivePassword(true) && res
        // 验证验证码
        if (this.code === '') {
          this.$set(this.errmsg, 'code', '请输入验证码')
          res = false
        } else {
          this.$set(this.errmsg, 'code', '')
          res = res && this.asyncCodeVerify
        }
        if (this.clauseCheck === true) {
          this.$set(this.errmsg, 'clause', '')
          res = res && true
        } else {
          this.$set(this.errmsg, 'clause', '请勾选同意协议')
          res = false
        }
        if (this.phoneExistVerify === 2) {
          res = res && true
        } else {
          res = false
        }

        return res
      },
      /**
       * 注册按钮点击
       */
      registerHandler() {
        if (this.verifyForm() === false) {
          return
        }
        this.errmsg = []
        // 调用发送短信接口
        this.$api.common.sendSms(this.phone, this.formKey, this.code, false).then(res => {
          this.visibleDialog = true
          // 1030 formKey过期 1012 验证码错误
          if (res.code === 0) {
            this.smsError = ''
          } else {
            this.smsError = res.msg
          }
        })
      },
      /**
       * 重新发送短信
       */
      resendClickHandler() {
        // 调用发送短信接口
        this.$api.common.sendSms(this.phone, this.formKey, this.code, true).then(res => {
          if (res.code === 0) {
            this.smsError = ''
          } else {
            this.smsError = res.msg
          }
        })
      },
      /**
       * 手机号码确认框打开事件
       */
      dialogOpenHandler() {
        this.$refs.resendCDBtn.start()
      },
      /**
       * 手机号码确认框关闭事件
       */
      dialogCloseHandler() {
        this.$refs.resendCDBtn.stop()
        this.smsError = ''
        this.phoneCode = ''
        this.visibleDialog = false
      },
      /**
       * 注册确认，正式注册
       */
      registerAffirmHandler() {
        if (this.phoneCode === '') {
          this.smsError = '请输入你收到的短信验证码'
          return
        }
        this.smsError = ''
        this.$api.user.register(this.phone, this.password, this.phoneCode, this.formKey).then(res => {
          if (res.code === 0){
            // 提示注册成功
            this.$msgbox.alert('注册成功，点击确定进行登录', {
              confirmButtonText: '确定',
              callback: action => {
                this.$router.replace({name:'Login'})
              }
            })
            // 跳转到登录页面
          }else{
            this.smsError = res.msg
          }
        })
      },
    },
    created() {
      this.$api.common.formKey().then(res => {
        console.log(res)
        if (res.code === 0) {
          this.formKey = res.data
          this.serverError = ''
        } else {
          this.serverError = '页面加载失败，请刷新页面'
        }
      })
    },
  }
</script>

<style scoped>
  .register-box {
    width: 1000px;
    margin: 0 auto;
    background-color: #fff;
    padding: 30px 20px;
    position: relative;
  }

  .register-form {
    width: 320px;
    margin: 0 auto;
  }

  .title {
    font-size: 32px;
    text-align: center;
    margin-bottom: 30px;
  }

  .login-info {
    font-size: 12px;
    position: absolute;
    right: 50px;
    top: 48px;
  }

  .input-row {
    margin-bottom: 15px;
    position: relative;
  }

  .other-link, .other-link:hover {
    font-size: 12px;
    margin-left: 5px;
    color: #00b7d3;
    text-decoration: none;
  }

  .errmsg {
    width: 300px;
    position: absolute;
    top: 10px;
    right: -320px;
    color: red;
  }

  .input-hint {
    font-size: 12px;
    color: #999;
  }

  .clause-links {
    font-size: 12px;
    color: #aaa;
    margin-top: 15px;
  }

  .dialog-row {
    /*height: 40px;*/
    /*line-height: 40px;*/
    margin-bottom: 30px;

  }

  .dialog-code {
    position: relative;
  }

  .dialog-hint {
    position: absolute;
    bottom: -30px;
    left: 5px;
    font-size: 12px;
    color: #67c23a;
  }
</style>
<style>
  .clause-links .el-checkbox__inner {
    border: 1px solid #00b7d3;
  }
</style>
